import { HorizontalBar } from 'vue-chartjs'

export default {
    extends: HorizontalBar,

    props: {
        chartData: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null,
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }

}



// WEBPACK FOOTER //
// ./src/components/Charts/HorizontalBar.js